<div class="div_loading">
    <div class="my-container" [hidden]="!loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>

<div class="row" style="display: flex !important;">
    <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-12 padding0">
        <input class="search_box" name="search_all" [(ngModel)]="search_all" (keyup)="check_access(4,1,'',1,2)"
            placeholder="{{ messageService.get_search() }}" autocomplete="off" style="width:100%">
    </div>
    <div class="col-xl-8 col-lg-8 col-md-7 col-sm-8 col-xs-12 padding0">
        <div class="service_pager">
            <span>
                <div class="video_div1" (click)="open_video()" *ngIf="video">
                    <mat-icon class="video">smart_display</mat-icon>
                </div>
                <button class="search1" (click)='open_detaile(0,3,0)'>
                    <span>{{ messageService.get_filter() }}</span>
                </button>
                <button class="search1" (click)='load_data2("all")' [ngClass]="{'active1':type_load == 'all'}">
                    <span>همه</span>
                </button>
                <button class="search1" (click)='load_data2("material")'
                    [ngClass]="{'active1':type_load == 'material'}">
                    <span>کالا</span>
                </button>
                <button class="search1" (click)='load_data2("service")' [ngClass]="{'active1':type_load == 'service'}">
                    <span>خدمات</span>
                </button>
                <div class="pager_pe">
                    <button (click)="check_access(4,4,0,1,1)" [disabled]='next_status'><i
                            class="fas fa-fast-forward"></i></button>
                    <button (click)="check_access(4,2,0,1,1)" [disabled]='next_status'><i
                            class="fas fa-forward"></i></button>
                    <button (click)="check_access(4,3,0,1,1)" [disabled]='pre_status'><i
                            class="fas fa-backward"></i></button>
                    <button (click)="check_access(4,5,0,1,1)" [disabled]='pre_status'><i
                            class="fas fa-fast-backward"></i></button>
                </div>
                <div class='navigation'><span> {{ page_number_first }}
                    </span><span>-</span><span> {{ page_number_second }} </span><span> of </span><span>
                        {{ count_total }} </span>
                </div>
            </span>
        </div>
    </div>
    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12 padding0 hidden-sm hidden-xs">
        <div class="pager_checkbox">
            <div class="pager_icon_en">
                <div class="excel">
                    <img src="../../../../../assets/images/excel.png" class="excel_icon cursor"
                        (click)="load_data(1,2,1,-1)">
                    <a href="" id="excel"><i class="far fa-file-excel" [hidden]="true"></i></a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="content-body control-content-body" (window:resize)="change_resize()">
    <mat-table [dataSource]="dataSource" style='min-width:100%' class='table-scroll mat_table_fa_without_scroll_bg pe1'>

        <ng-container matColumnDef="row">
            <mat-header-cell *matHeaderCellDef style='max-width:45px'
                (click)="reset_sort('wharehouse_order_id','desc')">
                <span>#</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style='max-width:45px'>{{ i +
                page_number_first }}</mat-cell>
            <mat-footer-cell *matFooterCellDef style='max-width:45px'></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef style="max-width:80px" [ngClass]="{active1:order == 'date ' + asc_desc }"
                (click)="sort('date',asc_desc)">
                <span>تاریخ فروش</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" class="number" style="max-width:80px"
                (click)="open_ref(i,x.ref)">
                {{ x.date }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="max-width:80px"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="material_type">
            <mat-header-cell *matHeaderCellDef style="max-width:80px"
                [ngClass]="{active1:order == 'wharehouse_material_type_title ' + asc_desc }"
                (click)="sort('wharehouse_material_type_title',asc_desc)">
                <span>نوع</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" class="number" style="max-width:80px"
                (click)="open_ref(i,x.ref)">
                {{ x.wharehouse_material_type_title || '-' }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="max-width:80px"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="material">
            <mat-header-cell *matHeaderCellDef style="min-width:280px"
                [ngClass]="{active1:order == 'title ' + asc_desc }" (click)="sort('title',asc_desc)">
                <span>عنوان کالا</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style="min-width:280px" (click)="open_ref(i,x.ref)">
                <div class="right">{{
                    x.title | substr:0:40 }}
                </div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="min-width:280px"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="customer">
            <mat-header-cell *matHeaderCellDef style='min-width:180px'
                [ngClass]="{active1:order == 'customer_title ' + asc_desc }" (click)="sort('customer_title',asc_desc)">
                <span>نام طرف حساب</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style='min-width:180px' (click)="open_ref(i,x.ref)">
                <div class="right">
                    {{x.customer_title }}</div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style='min-width:180px'></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="user">
            <mat-header-cell *matHeaderCellDef style='min-width:180px'
                [ngClass]="{active1:order == 'user_title ' + asc_desc }" (click)="sort('user_title',asc_desc)">
                <span>نام فروشنده</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style='min-width:180px' (click)="open_ref(i,x.ref)">
                <div class="right">
                    {{x.user_title }}</div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style='min-width:180px'></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="place">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'place ' + asc_desc }"
                (click)="sort('place',asc_desc)">
                <span>ورودی</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_ref(i,x.ref)">
                {{ x.place }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="number">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'wharehouse_order_number ' + asc_desc }"
                (click)="sort('wharehouse_order_number',asc_desc)">
                <span>تعداد</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_ref(i,x.ref)">
                {{ x.wharehouse_order_number }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="cost">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'wharehouse_order_cost ' + asc_desc }"
                (click)="sort('wharehouse_order_cost',asc_desc)">
                <span>قیمت کل فروش</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" class="number" (click)="open_ref(i,x.ref)">
                {{ x.wharehouse_order_cost | number }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="number">{{
                sum_amount_sale | number }}</mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="profit">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'profit ' + asc_desc }"
                (click)="sort('profit',asc_desc)">
                <span>سود کل فروش</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" class="number" [ngClass]="{'red':x.profit < 0}"
                (click)="open_ref(i,x.ref)">
                {{ x.profit | number }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="number">{{ sum_profit |
                number }}</mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="percent">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'wharehouse_order_profit ' + asc_desc }"
                (click)="sort('wharehouse_order_profit',asc_desc)">
                <span>درصد فروش</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" class="number" (click)="open_ref(i,x.ref)">
                {{ x.wharehouse_order_profit }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="porsant2">
            <mat-header-cell *matHeaderCellDef
                [ngClass]="{active1:order == 'wharehouse_order_profit_sale_order_for_persenel ' + asc_desc }"
                (click)="sort('wharehouse_order_profit_sale_order_for_persenel',asc_desc)">
                <span>پورسانت فروش</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" class="number"
                [ngClass]="{'red':x.wharehouse_order_profit_sale_order_for_persenel < 0}" (click)="open_ref(i,x.ref)">
                {{ x.wharehouse_order_profit_sale_order_for_persenel | number }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="number">{{ sum_profit_for_persenel |
                number
                }}</mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="profit_sale_order">
            <mat-header-cell *matHeaderCellDef
                [ngClass]="{active1:order == 'wharehouse_order_profit_sale_order ' + asc_desc }"
                (click)="sort('wharehouse_order_profit_sale_order',asc_desc)">
                <span>سود ناخالص فروش</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" class="number"
                [ngClass]="{'red':x.wharehouse_order_profit_sale_order < 0}" (click)="open_ref(i,x.ref)">
                {{ x.wharehouse_order_profit_sale_order | number}}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="number">{{ sum_profit_sale_order |
                number
                }}</mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="discount">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'wharehouse_order_discount ' + asc_desc }"
                (click)="sort('wharehouse_order_discount',asc_desc)">
                <span>تخفیف</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" class="number" (click)="open_ref(i,x.ref)">
                {{ x.wharehouse_order_discount | number}}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="number">{{ discount_all |
                number }}</mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="update_record">
            <mat-header-cell *matHeaderCellDef>
                <span>آپدیت رکورد</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="update_record(i,x.wharehouse_order_id)">
                <span *ngIf="x.wharehouse_order_id > 617738;else other1">
                    <span *ngIf="x.loading == false">
                        <mat-icon>refresh</mat-icon>
                    </span>
                    <div class="spinner-border spinner-border-sm" role="status" *ngIf="x.loading == true">
                        <span class="sr-only">Loading...</span>
                    </div>
                </span>
                <ng-template #other1>-</ng-template>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="number">
            </mat-footer-cell>
        </ng-container>

        <mat-header-row class="mat-header-row-dialog" *matHeaderRowDef="displayedColumns" color="primary">
        </mat-header-row>
        <mat-row class="mat-header-row-dialog" *matRowDef="let row;columns:displayedColumns;let i = index"
            (click)="mat_table_selectedRow = row" (mouseenter)="mat_table_hoverRow = row"
            [ngClass]="{'mat_table_selected': row === mat_table_selectedRow,mat_table_selected2:row.checked == true,'mat_table_hover': row === mat_table_hoverRow}"
            class="cursor"></mat-row>
        <mat-footer-row style="background: rgb(245 245 163) !important;bottom:-2px"
            *matFooterRowDef="displayedColumns;sticky : true">
        </mat-footer-row>
    </mat-table>

    <div class="row" class="preview1" [hidden]="count_total > 0">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div>
                <img src="../../../assets/images/preview.png">
            </div>
            <div class="preview2">{{ messageService.get_no_record_text() }}</div>
        </div>
    </div>
</div>